import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import Sortable from 'sortablejs';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/todo-page/subtodos';

Component('tr-todo-page-subtodos', {
  mixins: [eventListenerMixin],

  properties: {
    projectGuid: String,

    empty: {
      type: Boolean,
      default: true,
    },

    enablePlus: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.newButton = this.querySelector('.link-new-subtodo');
    this.listenTo(this.newButton, 'click', this.handleNewSubtodoClick.bind(this));

    if (this.enablePlus) {
      this.listenTo(this, 'tr-grid-subtodo-row:openTodo', this.handleOpenTodo.bind(this));
    }

    if (this.querySelector('.todos-completed')) {
      this.listenTo(this, 'tr-grid-subtodo-row:completed', this.handleSubtodoCompleted.bind(this));
    }

    this.listenTo(this, {
      'tr-grid-todo-title-cell:enter': this.handleTodoTitleCellEnter.bind(this),
      'tr-grid-todo-title-cell:pasteMultiLine': this.handleTodoTitleCellPasteMultiLine.bind(this),
    });

    this.initRowSortable();
  },

  handleOpenTodo(event) {
    const { detail: { detailUrl, openInTab } } = event;
    event.preventDefault();
    event.stopPropagation();
    if (openInTab) {
      window.open(detailUrl, '_blank');
    } else if (this.namespacedTrigger('openpage', { bubbles: true, detail: { url: detailUrl } })) {
      window.tower.stack.load(detailUrl, {
        replace: true,
      });
    }
  },

  handleTodoTitleCellEnter(event) {
    event.stopPropagation();

    const { value } = event.target.contentInput;
    const todoRow = closest(event.target, 'tr-grid-subtodo-row', this);
    if (!value) {
      todoRow.remove();
      return;
    }

    this.addNewSubtodoRowAfter({ afterRow: todoRow });
  },

  handleSubtodoCompleted({ target, detail }) {
    const { completed } = detail;
    if (completed) {
      this.querySelector('.todos-completed')
        .insertAdjacentElement('afterbegin', target);
    } else {
      this.querySelector('.todos-uncompleted')
        .insertAdjacentElement('beforeend', target);
    }
    this.reorder(target);
  },

  initRowSortable() {
    const sortableEl = this.querySelector('.sort-subtodos');

    Sortable.create(sortableEl, {
      group: 'tr-grid-subtodo-row',
      sort: true,
      draggable: 'tr-grid-subtodo-row[sortable]:not([editing])',
      animation: false,
      fallbackOnBody: true,
      invertSwap: true,
      forceFallback: (window.gon && window.gon.sortableFallback) || false,
      onStart: () => this.classList.add('sorting'),
      onEnd: ({
        to, from, item, oldDraggableIndex, newDraggableIndex,
      }) => {
        // eslint-disable-next-line no-param-reassign
        item.style.transform = null;
        this.classList.remove('sorting');

        if (from !== to || oldDraggableIndex !== newDraggableIndex) {
          this.reorder(item);
        }
      },
    });
  },

  handleNewSubtodoClick({ target }) {
    this.empty = false;
    this.removeEmptySubtodos();
    this.querySelector('.sort-subtodos')
      .insertAdjacentHTML('beforeend', target.dataset.template);
  },

  removeEmptySubtodos() {
    const emptySubtodos = [...this.querySelectorAll('tr-grid-subtodo-row')].filter(
      subtodo => !subtodo.querySelector('tr-grid-todo-title-cell textarea').value,
    );
    emptySubtodos.forEach(emptySubtodo => emptySubtodo.remove());
  },

  addNewSubtodoRowAfter({ afterRow }) {
    afterRow.insertAdjacentHTML('afterend', this.newButton.dataset.template);
    return afterRow.nextElementSibling;
  },

  handleTodoTitleCellPasteMultiLine(event) {
    event.stopPropagation();

    const { target, detail } = event;
    let subtodoRow = closest(target, 'tr-grid-subtodo-row', this);

    if (subtodoRow.guid) { // edit
      subtodoRow = this.addNewSubtodoRowAfter({ afterRow: subtodoRow });
      subtodoRow.addEventListener('tao:connected', () => {
        subtodoRow.createNewTodo(detail.content);
      });
    } else { // new
      subtodoRow.createNewTodo(detail.content);
    }
  },

  reorder(todo) {
    $.ajax({
      url: `/projects/${this.projectGuid}/todos/${todo.guid}/reorder`,
      type: 'post',
      data: {
        completed: todo.classList.contains('completed'),
        prev_todo_guid: todo.previousElementSibling ? todo.previousElementSibling.guid : '',
        next_todo_guid: todo.nextElementSibling ? todo.nextElementSibling.guid : '',
      },
    });
  },

  disconnected() {
    this.stopListening();
  },
});
